import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
export function ConsentIssuingStep() {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "issuing-heading", "aria-busy": "true", children: [_jsx("h3", { id: "issuing-heading", children: t('consent.issuing.heading') }), _jsx("p", { role: "status", children: t('consent.issuing.status') })] }));
}
//# sourceMappingURL=issuing-step.js.map